import * as angular from 'angular';

export class DefinitionsService {
    public regexGuid = new RegExp('[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i');
    public regexUrl = new RegExp('^(http|ftp|https)://[a-z0-9\-_]+(\.[a-z0-9\-_]+)+([a-z0-9\-\.,@\?^=%&;:/~\+#]*[a-z0-9\-@\?^=%&;/~\+#])', 'i');
    public regexWebsite = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
    public regexImg = new RegExp('<img[^\>]*>', 'ig');
    public regexEmail = new RegExp('^([a-zA-Z0-9]+([\\.+_-][a-zA-Z0-9]+)*)@(([a-zA-Z0-9]+((\\.|[-]{1,2})[a-zA-Z0-9]+)*)\\.[a-zA-Z]{2,6})[ ]*$');
    public regexNumbersAndLetters = new RegExp('^[a-zA-Z0-9]+[a-zA-Z0-9]$');
    public businessTypes = {
        Standard: { Name: 'Standard', ID: 0 },
        Pro: { Name: 'Pro', ID: 1 },
        Enterprise: { Name: 'Enterprise', ID: 2 }
    };
}

angular.module('app.common').service('definitionsService', DefinitionsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/definitions.service.ts